/**
 * Real network adapter — implement per phased backend plan.
 * Each method throws or returns empty until wired.
 */

const API_BASE = process.env.REACT_APP_COMMUNICATIONS_API || '';

function notImplemented(method) {
  const err = new Error(`communicationsApiAdapter.${method} is not implemented. Set REACT_APP_COMMUNICATIONS_USE_MOCK=true or implement the adapter.`);
  err.code = 'NOT_IMPLEMENTED';
  throw err;
}

function authHeaders() {
  const idToken = typeof localStorage !== 'undefined' ? localStorage.getItem('id_token') : null;
  const headers = { 'Content-Type': 'application/json' };
  if (idToken) headers.Authorization = idToken;
  return headers;
}

export function getApiBase() {
  return API_BASE;
}

export async function getProjectConnections(_projectId) {
  notImplemented('getProjectConnections');
}

export async function getCommunicationsFeed(_projectId, _filters) {
  notImplemented('getCommunicationsFeed');
}

export async function getProductivitySummary(_projectId) {
  notImplemented('getProductivitySummary');
}

export async function getCommunicationsIssues(_projectId) {
  notImplemented('getCommunicationsIssues');
}

export async function configureCommunications(_projectId, _config) {
  notImplemented('configureCommunications');
}

export async function listAvailableMicrosoftResources(_projectId, _resourceType) {
  notImplemented('listAvailableMicrosoftResources');
}

export async function refreshFeed(_projectId) {
  notImplemented('refreshFeed');
}

export async function askAlignmentQuestion(_projectId, _payload) {
  notImplemented('askAlignmentQuestion');
}

export async function recordAlignedDecision(_projectId, _payload) {
  notImplemented('recordAlignedDecision');
}

/** Phase 2: GET ${API_BASE}/communications/${projectId}/feed */
export async function fetchFeedFromApi(projectId, filters) {
  const params = new URLSearchParams();
  if (filters?.sources?.length) params.set('source', filters.sources.join(','));
  else if (filters?.source) params.set('source', filters.source);
  if (filters?.query) params.set('q', filters.query);
  const res = await fetch(`${API_BASE}/communications/${projectId}/feed?${params}`, {
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error(`Feed API failed (${res.status})`);
  return res.json();
}
